// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoadingSpinner_Wrapper__E0lKb","Dot":"LoadingSpinner_Dot__xPSh_","dots":"LoadingSpinner_dots__k3FAG","a":"LoadingSpinner_a__65Gwa","b":"LoadingSpinner_b__5NoiN"};